import React from 'react';
import Select from 'react-select';

const MultiSelectDropdown = ({ label, options, selectedValues, onChange }) => {
    return (
        <div className="col-md-3 mb-3">
            <label>{label}</label>
            <Select
                options={options}
                value={selectedValues}
                onChange={onChange}
                isMulti
                closeMenuOnSelect={false}
                placeholder={`Select ${label}`}
            />
        </div>
    );
};

export default MultiSelectDropdown;
